<template>
    <div class="top-bar__container d-flex align-items-center">
        <font-awesome-icon icon="rocket" class="icon"/>
        <span class="title flex-grow-1">{{title}}</span>
        <div class="icon--user"><span><font-awesome-icon icon="user"/></span></div>
        <div class="mr-5"><span>{{currentUser.email}}</span></div>
        <div><a v-on:click.stop.prevent="logout" :style="{cursor: 'pointer'}" >Logout</a></div>

        <div> - TEMP: {{date | moment("dddd, MMMM Do YYYY HH:mm")}}</div>
    </div>
</template>

<script>

    import firebase from 'firebase/app';

    export default {
        name: "TopBar",

        props: {
            title: String
        },

        data: () => {
            return {
                currentUser: null,
                date: null
            }
        },

        methods: {

            logout() {
                firebase.auth().signOut()
                    .then(() => {
                        this.$router.push({name: 'Login'})
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },

        created() {

            this.date = this.$moment('2018-08-07T17:39:20+02:00');
            this.currentUser = firebase.auth().currentUser;
        }
    }
</script>

<style scoped lang="scss">

    @import "~styles/colors";

    .top-bar__container {
        border-bottom: 1px solid $border-color;
        padding: 1rem 1rem;
        background-color: $top-bar-bg;
    }

    .title {
        font-size: 1.2rem;
    }

    .user {
        font-size: 1rem;
    }

    .icon {
        font-size: 1.5rem;
        color: $color-red;
        margin-right: 2rem;
    }

    .icon--user {
        color: #bbbbbb;
        width: 2rem;
        height: 2rem;
        margin-right: 1rem;
        border-radius: 50%;
        background-color: #efefef;
        font-size: 1.2rem;

        display: flex;
        adjust-content: center;
        justify-content: center;

        span {
            display: inline-block;
        }
    }
</style>